import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
import BackButton from 'src/legacy/components/BackButton';
import DriftIcon from 'src/legacy/images/drift.svg';
import DriftActivationPage from './DriftActivationPage';
import DeactivateIntegrationContainer from 'src/legacy/components/DeactivateIntegration/index'
import { localizedStrings } from 'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/redux/actions/integrations';

class FreshchatView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state={
      deleteConfirmation: false
    }

    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedDrift = localizedStrings.components.integrations.drift;
  }

  _handleDeactivateClicked(){
   this.setState({
     deleteConfirmation: true
   })
  }

  componentDidMount(){

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }

  }
  
  render(){
    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton className={styles.back} title={this.localizedCommons.actions.back} onClick={() => {
              this.props.handleIntegrationsBackButton();
            }} />
            <div className={ styles.heading }>
              <Image src={DriftIcon} />
              <h2 className={styles.name}>{ this.localizedDrift.title }</h2>
              <p className={styles.description}>{ this.localizedDrift.sub_text }</p>
              { this.props.integration &&
                <button className={styles.button}  onClick={this._handleDeactivateClicked}>
                  { this.localizedIntegrations.actions.deactivate }
                </button>
              }
            </div>  
          </Col>
          <Col md={9} className={styles.right}>
            <DriftActivationPage store={this.context.store} integration = { this.props.integration }/>  
          </Col>
          <DeactivateIntegrationContainer 
            name={this.localizedDrift.title}
            type="driftchat"
            message={this.localizedDrift.deactivate_slider.sub_text}
            show={this.state.deleteConfirmation}
            onCancel={()=> {
              this.setState({
              deleteConfirmation: false
              })
            }}
          />
        
        </Row>
        
      </div>
    );
  }
}

export default FreshchatView;